import React from 'react';
import { Card } from './ui/Card';
import { Quote } from 'lucide-react';
interface TestimonialProps {
  initials: string;
  quote: string;
  author: string;
  location?: string;
  className?: string;
}
export function Testimonial({
  initials,
  quote,
  author,
  location,
  className
}: TestimonialProps) {
  return <Card className={`p-6 flex flex-col h-full bg-white/80 backdrop-blur-sm border-sage-mist ${className}`} data-id="element-383">
      <div className="flex items-start gap-4 mb-4" data-id="element-384">
        <div className="w-12 h-12 rounded-full bg-forest-mist text-forest-deep flex items-center justify-center font-serif font-bold text-lg shrink-0 border border-sage-mist" data-id="element-385">
          {initials}
        </div>
        <Quote className="w-6 h-6 text-honey mt-1 opacity-50" data-id="element-386" />
      </div>
      <p className="text-forest/80 italic mb-6 flex-grow leading-relaxed" data-id="element-387">
        "{quote}"
      </p>
      <div className="mt-auto" data-id="element-388">
        <p className="font-bold text-forest-deep text-sm uppercase tracking-wider" data-id="element-389">
          {author}
          {location && <span className="font-normal text-forest/60 normal-case" data-id="element-390">
              , {location}
            </span>}
        </p>
      </div>
    </Card>;
}